/* 
 * DialogPlayerAnswerTimerMediator.js
 * 
 * @author Olivier van der Pool for Ranj
 */

import NGTDialogPlayerEvent from "../NGTDialogPlayerEvent";

export default class DialogPlayerAnswerTimerMediator {
    constructor(target, dispatcher) {
        this._skin = target;
        this._dispatcher = dispatcher;
    }

    initialize() {
        this._skin.visible = false; //stay invisible until the fist time tick occured
        this._timeValue = 0; //the timer time value in milliseconds

        this._addEventListeners();
    }

    destroy() {
        this._removeEventListeners();
    }

    _addEventListeners() {
        this._handleTimeTickFunction = this._handleTimeTick.bind(this);
        this._handleTimeOutFunction = this._handleTimeOut.bind(this);
        this._dispatcher.addEventListener(NGTDialogPlayerEvent.ANSWER_TIMER, this._handleTimeTickFunction);
        this._dispatcher.addEventListener(NGTDialogPlayerEvent.DIALOG_TIME_OUT, this._handleTimeOutFunction);
    }

    _removeEventListeners() {
        this._dispatcher.removeEventListener(NGTDialogPlayerEvent.ANSWER_TIMER, this._handleTimeTickFunction);
        this._dispatcher.removeEventListener(NGTDialogPlayerEvent.DIALOG_TIME_OUT, this._handleTimeOutFunction);
    }

    _handleTimeTick({ params }) {
        if (!this._skin.visible) this._skin.visible = true;

        this._timeValue = params.data;
        this._updateTime();
    }

    _handleTimeOut(event) {
        // do nothing!
    }

    _updateTime() {
        let s = this._timeValue;
        const ms = s % 1000;
        s = (s - ms) / 1000;
        let secs = s % 60;
        s = (s - secs) / 60;
        let mins = s % 60;

        secs < 10 ? secs = `0${secs}` : null;
        mins < 10 ? mins = `0${mins}` : null;
        this._skin.timeField.text = `${mins}:${secs}`;
    }
}